<template>
  <div :class="`chat-avatar ${isMensagemDoAtendente ? 'ms-4' : 'me-4'}`">
    <v-avatar
      :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
      size="38"
    >
      <span :class="`font-weight-bold ${$vuetify.theme.dark ? 'white--text' : 'primary--text'}`">
        {{
          isMensagemDoAtendente
            ? atendenteNome.substr(0, 1)
            : solicitanteNome.toUpperCase().substr(0, 1)
        }}
      </span>
    </v-avatar>
  </div>
</template>

<script>
export default {
  props: {
    atendenteNome: {
      type: String,
      required: true,
    },
    solicitanteNome: {
      type: String,
      required: true,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
